export default __webpack_public_path__ + "static/media/spoolSheetsCover.e1ab19a5.jpg";